import './ComingSoon.css';

// Pre-launch gate. Shown only on the LIVE domain (see shouldShowComingSoon in
// App.jsx); preview channels + localhost + ?preview=1 see the real app.
export function ComingSoon() {
  return (
    <div className="cs">
      <svg className="cs__route" viewBox="0 0 1200 630" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <path d="M70 470 C 220 470, 240 300, 380 300 S 560 150, 720 200 S 980 360, 1140 250"
              fill="none" stroke="#F0A500" strokeWidth="6" strokeLinecap="round" opacity="0.18"/>
        <circle cx="70" cy="470" r="9" fill="#6AB880" opacity="0.5"/>
        <circle cx="1140" cy="250" r="9" fill="#E84838" opacity="0.5"/>
      </svg>

      <div className="cs__inner">
        <img src="/motoroam_logo.png" alt="" className="cs__mark" />
        <h1 className="cs__word">MOTOROAM</h1>
        <span className="cs__badge">Coming soon</span>
        <p className="cs__tag">Motorcycle route planning &amp; guided tours — built for riders.</p>
        <a className="cs__mail" href="mailto:info@motoroam.app">info@motoroam.app</a>
      </div>
    </div>
  );
}
